<rt-collapsible-card
  rtCollapsibleCardAnalytics
  analyticsKey="job"
  [uniqKey]="uniqKey()"
  [collapseDisabled]="!collapsible()"
  hasHeaderHorizontalPadding="false"
  hasBorder="false"
  hasRadius="false"
>
  <div
    leftSlot
    [attr.margin-left]="hasDragHandle() ? null : true"
    layout
    layout-align-items-center
    min-width-0
  >
    @if (hasDragHandle()) {
      <div (click)="$event.stopImmediatePropagation()">
        <ng-content select="[dragHandle]" />
      </div>
    }
    <a
      rtTooltip
      [rtTooltipTemplate]="offerTitleTooltipTemplate()"
      [rtTooltipEnabled]="!!offerTitleTooltipTemplate()"
      rtTooltipPosition="leftbelow"
      rtTooltipType="light"
      [rtTooltipHasShadow]="true"
      [rtTooltipHasBorder]="true"
      [rtTooltipArrowPush]="true"
      [rtTooltipMaxWidth]="320"
      [routerLink]="offerUrl()"
      (click)="$event.stopImmediatePropagation()"
      class="left-content"
      layout
      layout-align-items-center
      min-width-0
    >
      <rt-offer-status-indicator
        [offerStatus]="placement().offer!"
        margin-right-small-x
        [attr.margin-left-small-xxx]="hasDragHandle() ? true : null"
      />
      <rt-heading [truncated]="true">
        <rt-truncate
          [attr.data-cy]="'candidate-profile-placement:job-title:' + placement().offer?.id"
        >
          {{ placement().offer!.title }}
        </rt-truncate>
      </rt-heading>
    </a>
  </div>
  <div
    rightSlot
    layout
    layout-align-items-center
    [attr.margin-right]="canOpenMoreDropdown() ? true : null"
    [attr.margin-right-small]="canOpenMoreDropdown() ? null : true"
  >
    @if (canPreviewJob()) {
      <rt-icon-button
        variant="plain"
        size="small"
        iconName="open-in-new"
        [rtTooltip]="'app.candidate.placements.preview_job' | translate"
        rtTooltipPosition="above"
        (click)="onPreviewJobClick($event)"
        [attr.margin-right-small-xx]="canOpenMoreDropdown() ? true : null"
        [attr.data-cy]="'candidate-profile-placement:preview-job-button:' + placement().offer?.id"
      />
    }

    @if (canOpenMoreDropdown()) {
      <rt-icon-button
        #moreDropdownTrigger="rtOverlayOrigin"
        rt-overlay-origin
        variant="plain"
        iconName="more-horiz"
        size="small"
        [pressed]="moreDropdown.open"
        (click)="onMoreClick($event)"
        [attr.data-cy]="
          'candidate-profile:candidate-profile-placement:more-button:' + placement().offer?.id
        "
      />

      <ng-template
        #moreDropdown="rtConnectedOverlay"
        rt-connected-overlay
        hasBackdrop
        [origin]="moreDropdownTrigger"
        [positions]="dropdownPosition"
        (backdropClick)="moreDropdown.toggleOverlay(false)"
      >
        <ng-container
          [ngTemplateOutlet]="moreDropdownTemplate()"
          [ngTemplateOutletContext]="{ connectedOverlay: moreDropdown }"
        />
      </ng-template>
    }
  </div>
  <div collapsible layout-full-width padding-bottom-small padding-lr>
    <div layout layout-full-width>
      <div
        rtTooltip
        [rtTooltipTemplate]="disqualifiedTooltipTemplate()"
        [rtTooltipEnabled]="
          !!disqualifiedTooltipTemplate() && !!placement().disqualifyReason?.length
        "
        rtTooltipPosition="leftbelow"
        rtTooltipType="light"
        [rtTooltipHasShadow]="true"
        [rtTooltipHasBorder]="true"
        [rtTooltipArrowPush]="true"
        [rtTooltipMaxWidth]="320"
        [rtTooltipArrowPositionOffset]="{ offsetX: 0, offsetY: -24 }"
        [rtTooltipPositionOffset]="-45"
        (click)="$event.stopImmediatePropagation()"
        layout-vertical
        layout-flex-1-0
        width-0
        margin-right-small-xx
        [attr.margin-top-small-x]="!placement().disqualifyReason || null"
      >
        @if (!placement().disqualifyReason) {
          @if (!isLoading()) {
            <div layout layout-full-width>
              <rt-stage-select
                [placement]="placement()"
                [stages]="stages()"
                [stageAutomationsFetchHandler]="stageAutomationsFetchHandler()"
                [placementActions]="placementActions()"
                (proceedClick)="proceedClick.emit($event)"
                (showAutomatedActionDetailsClick)="showAutomatedActionDetailsClick.emit($event)"
                min-width-0
              />
              @if (placement().overdueDiff && placement().overdueDiff! < 0) {
                <rt-overdue-candidate-badge
                  [hasTooltip]="true"
                  [overdueDiff]="placement().overdueDiff!"
                  fontSize="font-size-default"
                  borderRadius="border-radius-large"
                  margin-left-small-x
                />
              }
            </div>
          } @else {
            <rt-spinner variant="small" layout-align-self-start />
          }
          <span margin-top-small-x text-line-small>
            <ng-container *ngTemplateOutlet="createdAtTpl" />
          </span>
        } @else {
          <span layout min-width-0>
            <rt-icon
              name="block"
              colorToken="colorIconCriticalDefault"
              size="small-x"
              margin-right-small-xx
            />
            <rt-truncate min-width-0 text-critical text-line-small>
              {{ placement().disqualifyReason }}
            </rt-truncate>
          </span>
          <rt-truncate margin-top-small-xx text-line-small>
            {{
              'app.candidate.placements.row.disqualified_in'
                | translate: { stage: placement().stage.name }
            }}
          </rt-truncate>
          <span text-line-small>
            <ng-container *ngTemplateOutlet="createdAtTpl" />
          </span>
        }
      </div>
      @if (hasEvaluationImprovements() && theme() && evaluationScale()) {
        <rt-candidate-ratings-score-chart
          [score]="scoreForChart()"
          [evaluationScale]="evaluationScale()!"
          [theme]="theme()!"
          [isHidden]="isRatingHidden()"
          [showTooltip]="false"
          [size]="77"
          [showScoreCaption]="false"
          scoreIconSize="small"
          scoreFontSize="small"
          scoreFontWeight="semi-bold"
          (click)="evaluationMeterClick.emit(placement().id)"
        />
      } @else {
        <rt-placement-evaluation-meter
          [evaluationInsights]="evaluationInsights()"
          [placement]="placement()"
          [interviewResults]="interviewResults()"
          [hiddenResultPreview]="hiddenResultPreview()"
          [evaluationScale]="evaluationScale()"
          [hasEvaluationImprovements]="hasEvaluationImprovements()"
          (click)="evaluationMeterClick.emit(placement().id)"
        />
      }
    </div>
    @if (placement().hiredInThisPlacement && !placement().disqualifyReason) {
      <rt-divider variant="line default" />
      <rt-placement-row>
        <span leftSlot>{{ 'app.candidate.placements.row.hired_date' | translate }}</span>
        <span rightSlot>
          <ng-container
            *ngTemplateOutlet="
              dateTemplate;
              context: { date: placement().hiredAt, showRelativeDate: true }
            "
          />
        </span>
      </rt-placement-row>
      <rt-placement-row>
        <span leftSlot>{{ 'app.candidate.placements.row.start_date' | translate }}</span>
        <span rightSlot>
          @if (placement().jobStartsAt) {
            <ng-container
              *ngTemplateOutlet="
                dateTemplate;
                context: { date: placement().jobStartsAt, showRelativeDate: false }
              "
            />
          } @else {
            <span text-darkest>—</span>
          }
        </span>
      </rt-placement-row>
      <rt-placement-row>
        <span leftSlot>
          {{ 'app.candidate.placements.row.work_location' | translate }}
        </span>
        <div
          rightSlot
          layout
          layout-align-items-center
          min-width-0
          [attr.negative-margin-right-small-x]="placementActions().editWorkLocations ? true : null"
        >
          <ng-container
            *ngTemplateOutlet="
              workLocationButtonTpl;
              context: { fontSizeSmall: true, textStrong: true }
            "
          />
        </div>
      </rt-placement-row>
    }

    <rt-action-buttons
      [rtWalkthroughOriginStepId]="'walkthrough-step-proceed-disqualify-7'"
      [placement]="placement()"
      [placementActions]="placementActions()"
      [stages]="stages()"
      [disqualifyReasons]="disqualifyReasons()"
      [isLoading]="isLoading()"
      [openingIssue]="openingIssue()"
      (proceedClick)="proceedClick.emit($event)"
      (editHiringDetailsClick)="editHiringDetailsClick.emit($event)"
      (disqualifyReasonSelect)="disqualifyReasonSelect.emit($event)"
      (disqualifyReasonsActionsDetails)="disqualifyReasonsActionsDetails.emit($event)"
      (requalifyClick)="requalifyClick.emit($event)"
      (editDisqualifyReasonsClick)="editDisqualifyReasonsClick.emit()"
    />
  </div>
</rt-collapsible-card>

<ng-template #dateTemplate let-date="date" let-showRelativeDate="showRelativeDate">
  {{ date | amDateFormat: 'll' }}&nbsp;
  @if (showRelativeDate) {
    (<rt-date [time]="date" [colorDarkest]="true" [tinyWithSuffix]="true" variant="small" />)
  }
</ng-template>

<ng-template #workLocationButtonTpl let-fontSizeSmall="fontSizeSmall" let-textStrong="textStrong">
  <rt-candidate-work-locations-button
    [locationIds]="locationIds()"
    [canEdit]="placementActions().editWorkLocations"
    [emptyStateTemplate]="noLocationTemplate"
    [colorTextStrong]="textStrong"
    forceEditIconVisible="true"
    [fontSizeSmall]="fontSizeSmall"
    [small]="true"
    (edit)="editWorkLocation.emit({ placement: placement() })"
  />

  <ng-template #noLocationTemplate>
    {{ 'app.candidate.placements.no_location' | translate }}
  </ng-template>
</ng-template>

<ng-template #createdAtTpl>
  {{ 'app.candidate.placements.row.assigned' | translate }}
  <span [rtTooltip]="placement().createdAt | amDateFormat: 'lll'">
    {{ placement().createdAt | amDateFormat: 'll' }}</span
  >
  <span margin-lr-small-xx>•</span>
  <ng-container
    *ngTemplateOutlet="workLocationButtonTpl; context: { fontSizeSmall: false, textStrong: false }"
  />
</ng-template>
